import React, { useState, useRef } from 'react';

const EmployeeRegistration = ({ onEmployeeAdded, currentDate }) => {
  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [dni, setDni] = useState('');
  const [scheduleStart, setScheduleStart] = useState('08:00');
  const [scheduleEnd, setScheduleEnd] = useState('17:00');
  const nombreInputRef = useRef(null);

  const generateUniqueId = () => {
    return 'emp-' + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = generateUniqueId();
    const newEmployee = {
      id,
      nombre: nombre.trim(),
      apellidos: apellidos.trim(),
      dni: dni.trim(),
      fechaIngreso: currentDate,
      qrCode: id,
      scheduleStart,
      scheduleEnd
    };

    await onEmployeeAdded(newEmployee);

    setNombre('');
    setApellidos('');
    setDni('');
    setScheduleStart('08:00');
    setScheduleEnd('17:00');
    
    if (nombreInputRef.current) {
      nombreInputRef.current.focus();
    }
  };

  return (
    <div className="w-full max-w-md mx-auto p-8 glass-card rounded-2xl shadow-2xl border-slate-800/80">
      <h2 className="text-2xl font-bold mb-6 text-slate-100 bg-clip-text text-transparent bg-gradient-to-r from-slate-100 to-slate-300">
        Registro de Empleado
      </h2>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-slate-400 text-sm font-semibold mb-2">Nombre Completo</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            ref={nombreInputRef}
            className="w-full px-4 py-2.5 bg-slate-950/70 border border-slate-800 rounded-xl text-slate-100 placeholder-slate-600 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all duration-200"
            placeholder="Ej. Juan Carlos"
            required
          />
        </div>
        <div>
          <label className="block text-slate-400 text-sm font-semibold mb-2">Apellidos Completos</label>
          <input
            type="text"
            value={apellidos}
            onChange={(e) => setApellidos(e.target.value)}
            className="w-full px-4 py-2.5 bg-slate-950/70 border border-slate-800 rounded-xl text-slate-100 placeholder-slate-600 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all duration-200"
            placeholder="Ej. Perez Gomez"
            required
          />
        </div>
        <div>
          <label className="block text-slate-400 text-sm font-semibold mb-2">DNI</label>
          <input
            type="text"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            className="w-full px-4 py-2.5 bg-slate-950/70 border border-slate-800 rounded-xl text-slate-100 placeholder-slate-600 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all duration-200"
            placeholder="Número de DNI"
            required
          />
        </div>
        <div>
          <label className="block text-slate-400 text-sm font-semibold mb-2">Fecha de Ingreso</label>
          <input
            type="date"
            value={currentDate}
            className="w-full px-4 py-2.5 bg-slate-950/30 border border-slate-900 rounded-xl text-slate-500 cursor-not-allowed select-none focus:outline-none"
            readOnly
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="scheduleStart" className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
              Hora de Entrada
            </label>
            <input
              id="scheduleStart"
              type="time"
              value={scheduleStart}
              onChange={(e) => setScheduleStart(e.target.value)}
              className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-slate-100 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all font-mono"
            />
          </div>
          <div>
            <label htmlFor="scheduleEnd" className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
              Hora de Salida
            </label>
            <input
              id="scheduleEnd"
              type="time"
              value={scheduleEnd}
              onChange={(e) => setScheduleEnd(e.target.value)}
              className="w-full px-4 py-3 bg-slate-900 border border-slate-800 rounded-xl text-slate-100 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all font-mono"
            />
          </div>
        </div>
          
        <button 
          type="submit"
          className="w-full mt-2 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold rounded-xl shadow-lg shadow-cyan-500/10 hover:shadow-cyan-500/20 hover:-translate-y-0.5 transition-all duration-200"
        >
          Registrar Empleado
        </button>
      </form>
    </div>
  );
};

export default EmployeeRegistration;